<template>
  <router-view></router-view>
</template>
<script type="text/javascript">
export default {
  name: 'Renewal'
}

</script>



// WEBPACK FOOTER //
// src/Osm/Renewal/containers/Renewal.vue